import React from 'react';
import propTypes from 'prop-types';
import EditorDocumentName from './editorDocumentName';

const Name = (props) => {
  const {
    listItem: { component },
    formatType,
  } = props;

  return (
    <>
      {
        {
          editorDoc: <EditorDocumentName formatType={formatType} />,
        }[component]
      }
    </>
  );
};

Name.propTypes = {
  listItem: propTypes.objectOf(propTypes.string).isRequired,
};

export default Name;
